module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Copyright")])])]), _vm._v(" "), _c('h1', {
    staticClass: "head"
  }, [_vm._v("\n\tCopyright")]), _vm._v(" "), _c('div', {
    staticClass: "halftitle"
  }, [_c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tDiversion Books")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tA Division of Diversion Publishing Corp.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\t443 Park Avenue South, Suite 1004")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tNew York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.diversionbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tCopyright © 1993 by Anna Eberhardt")])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tAll rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tFor more information, email "), _c('a', {
    attrs: {
      "href": "http://info@diversionbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("info@diversionbooks.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tFirst Diversion Books edition May 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tISBN: 9781626810181")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_c('strong', [_vm._v("Also by Tiffany White")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Dark & Stormy Knight")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Kiss in the Dark")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bad Attitude")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheap Thrills")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forbidden Fantasy")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love, Me")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naughty by Night")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "text-indent": "1.5em",
      "font-size": "1em",
      "line-height": "1.4"
    }
  }, [_vm._v("Open Invitation")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Restless Nights")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 6′1″ Grinch")])]), _vm._v(" "), _c('p')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff2819e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap133645.vue
// module id = 63
// module chunks = 0